import React from "react";
import "./uploadAnimation.scss";

const UploadAnimation = () => {
  return (
    <div className="upload-animation">
      <svg
        className="upload-animation__cloud"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 160 117"
        fill="none"
        aria-hidden="true"
      >
        <defs>
          <linearGradient
            id="uploadCloudGradient"
            x1="218.91"
            y1="-0.37"
            x2="25.99"
            y2="76.76"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#FFFFFF" />
            <stop offset="1" stopColor="#D7D7D7" />
          </linearGradient>
        </defs>
        <path
          d="M40,117C28.97,117 19.55,113.16 11.73,105.48C3.92,97.8 0,88.42 0,77.33C0,67.82 2.85,59.35 8.55,51.92C14.24,44.48 21.7,39.73 30.91,37.66C33.94,26.45 40,17.37 49.09,10.42C58.18,3.47 68.48,0 80,0C94.18,0 106.21,4.97 116.1,14.9C125.98,24.84 130.91,36.93 130.91,51.19C139.27,52.16 146.21,55.79 151.73,62.07C157.25,68.35 160.01,75.69 160,84.09C160,93.23 156.82,101 150.46,107.41C144.1,113.81 136.37,117 127.27,117H40Z"
          fill="url(#uploadCloudGradient)"
        />
      </svg>

      <svg
        className="upload-animation__arrow"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 84 81"
        fill="none"
        aria-hidden="true"
      >
        <rect
          x="4"
          y="4"
          width="76"
          height="73"
          rx="4"
          stroke="#808080"
          strokeWidth="4"
          fill="#FFFFFF"
        />
        <path
          d="M37.354,50.374H46.17C47.382,50.374 48.374,49.382 48.374,48.17V37.15H51.879C53.84,37.15 54.832,34.769 53.443,33.381L43.327,23.264C43.123,23.059 42.881,22.897 42.614,22.787C42.347,22.676 42.062,22.619 41.773,22.619C41.484,22.619 41.198,22.676 40.932,22.787C40.665,22.897 40.423,23.059 40.219,23.264L30.102,33.381C28.714,34.769 29.683,37.15 31.645,37.15H35.15V48.17C35.15,49.382 36.141,50.374 37.354,50.374Z"
          fill="#808080"
        />
        <rect
          x="26.333"
          y="63.354"
          width="30.857"
          height="4.408"
          rx="2.204"
          fill="#808080"
        />
      </svg>
    </div>
  );
};

export default UploadAnimation;
